import type { IIconProps } from '@frontend/pole-ui/lib/components/Icon'
import type { EUserPermission } from '@/types'

export enum ENavLink {
  FERTILIZERS = 'FERTILIZERS',
  FINANCING = 'FINANCING',
  FINANCING_MONEY = 'FINANCING_MONEY',
  FINANCING_CONSULT = 'FINANCING_CONSULT',
  FINANCING_SELF = 'FINANCING_SELF',
  HARVEST_SALE = 'HARVEST_SALE',
  PRICE_REQUESTS = 'PRICE_REQUESTS',
  JOURNAL = 'JOURNAL',
  PROFILE = 'PROFILE',
}

export interface NavLink {
  id: ENavLink
  text: string
  url: string
  icon: IIconProps['component']
  permissions?: EUserPermission[]
  subLinks?: NavSubLink[]
}

export interface NavSubLink extends NavLink {
  subText: string
  isAccent?: boolean
}

export interface IAuxiliaryLink {
  textId: string
  url: string
}
